<template>
  <el-upload
    v-loading.fullscreen.lock="loading"
    element-loading-text="文件上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    class="avatar-uploader"
    :headers="uploadHeaders"
    :action="action"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    accept="image/jpeg,image/png,image/jpg"
    name="File"
    :data="{ type: type }"
  >
    <div v-if="imageUrl && showImage" class="posR">
      <img :src="imageUrl" class="avatar" />
      <div class="deleteIcon" v-if="showDelete" @click.stop="handleRemove()">
        <i class="el-icon-circle-close"></i>
      </div>
    </div>
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>
<script>
import { uploadUrl } from "../../util/state";
export default {
  props: {
    showImage: {
      type: Boolean,
      default: true,
    },
    fileUrl: {
      type: String,
      default: "",
    },
    fileType: {
      type: String,
      default: "image",
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "venue",
    },
  },
  data() {
    return {
      imageUrl: "",
      action: "",
      uploadHeaders: {},
      loading: false,
    };
  },

  created() {
    console.log("fileUrl", this.fileUrl);
    if (this.fileUrl) {
      this.imageUrl = this.fileUrl;
      console.log("imageUrl", this.imageUrl);
    } else {
      this.imageUrl = "";
    }
    this.uploadHeaders = { Authorization: "Bearer " + this.$store.state.token };
    this.action = uploadUrl;
  },
  watch: {
    fileUrl: {
      handler(newVal) {
        this.imageUrl = newVal || "";
      },
      immediate: true
    }
  },
  methods: {
    handleRemove() {
      this.imageUrl = "";
      this.$emit("delete", {});
    },
    handleAvatarSuccess(res, file) {
      this.loading = false;
      this.imageUrl = res.response[0];
      this.$emit("upload", res.response[0]);
    },
    beforeAvatarUpload(file) {
      let isVideo = true;
      const isLt500M = file.size / 1024 / 1024 < 500;
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (this.fileType == "video") {
        isVideo = file.type === "video/mp4";
        if (!isVideo) {
          this.$message.error("上传视频只能是MP4,RMVB,AVI格式!");
          return false;
        }
        if (!isLt500M) {
          this.$message.error("上传视频大小不能超过500MB!");
          return false;
        }
      } else {
        if (!isLt50M) {
          this.$message.error("上传图片大小不能超过 50MB!");
        }
      }
      this.loading = true;
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.posR {
  position: relative;
}
.deleteIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
}
</style>
